// extracted by mini-css-extract-plugin
export var colorSquare = "_k0-0";
export var danger = "_k0-5";
export var lightPink = "_k0-8";
export var neutralBlue = "_k0-7";
export var neutralYellow = "_k0-6";
export var normal = "_k0-1";
export var primary = "_k0-2";
export var primaryLight = "_k0-3";
export var solidBlack = "_k0-g";
export var solidGreen = "_k0-b";
export var solidLightBlue = "_k0-d";
export var solidNavy = "_k0-c";
export var solidOrange = "_k0-f";
export var solidPink = "_k0-e";
export var solidRed = "_k0-9";
export var solidYellow = "_k0-a";
export var success = "_k0-4";